import { GatewayControleQuinquennal } from "@conformite/gateway";
import {
  displayErrorToast,
  displaySucessToast,
} from "@endya-conformite/ui-kit";
import { ControleQuinquennalApi } from "@src/data/controle-quinquennal/controle-quinquennal.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

type UpdateRemediationParams = {
  idControleQuinquennal: string;
  idAxe: string;
  idRemediation: string;
  payload: GatewayControleQuinquennal.ControleQuinquenalRemediationRequestType;
  files: File[];
};

export const useUpdateRemediationMutation = (idEntreprise: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      idControleQuinquennal,
      idAxe,
      idRemediation,
      payload,
      files,
    }: UpdateRemediationParams) =>
      ControleQuinquennalApi.updateRemediation(
        idControleQuinquennal,
        idAxe,
        idRemediation,
        payload,
        files
      ),
    onSuccess: (_, variables) => {
      const { idControleQuinquennal, idAxe } = variables;
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.conversationsByAxes(idAxe),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.detail(idEntreprise),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.axesWithFiles(
          idControleQuinquennal,
          idAxe
        ),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.remediationsByAxe(
          idControleQuinquennal,
          idAxe
        ),
      });
      // Le passage en remédiation change le statut de l'axe, donc la
      // conformité vérificateur de la liste.
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.lists(),
      });
      displaySucessToast("Rémédiation modifiée avec succès");
    },
    onError: () => {
      displayErrorToast(
        "Une erreur est survenue lors de la modification de la rémédiation"
      );
    },
  });
};
